"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrathEffectHandler = exports.WrathEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class WrathEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Wrath;
        this.__typeName = "Wrath";
        this.name = "Wrath";
        this.harmful = false;
    }
}
exports.WrathEffectArgs = WrathEffectArgs;
let WrathEffectHandler = class WrathEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Attack, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Wrath_OnAttack", {}));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
WrathEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Wrath)
], WrathEffectHandler);
exports.WrathEffectHandler = WrathEffectHandler;
